import React from 'react';

import HeroHeading from 'bento-ordering/base/ui_components/HeroHeading';

function DineInHeader() {
  return <HeroHeading>Order for dine-in</HeroHeading>;
}

export default DineInHeader;
